import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import { FormattedMessage } from "react-intl";
import FiltersControlFacet from "./filters-control-facet";
import FiltersControlReset from "./filters-control-reset";
import FiltersControlField from "./filters-control-field";
import FiltersControlSorting from "./filters-control-sorting";
import { useSolrContext } from "@e-fork/solr";
import FiltersControlSearch from "./filters-control-search";

import classNames from "classnames";

const Filters = ({ className, tags = false, wrapper = true }) => {
  const { config, currentFilters } = useSolrContext();

  const filtersExist =
    config.fields.length > 0 || config.facets.length > 0 || config.search;

  const wrapperClassNames = classNames("filter-wrapper", {
    [className]: className,
  });

  const hasMatchingTags = (_tags) => {
    if (!_tags) return false;
    return tags.every((tag) => _tags.includes(tag));
  }

  // If no filters are exposed, return null.
  if (!filtersExist) return null;

  const filters = (
    <>
      {!!config.search && (
        <div className="filters-controlsection">
          <div className="filters-controlsection-controls">
            <FiltersControlSearch />
          </div>
        </div>
      )}

      {!!config.facets?.length && (
        <div className="filters-controlsection">
          <div className="filters-controlsection-controls">
            {config.facets
              .filter((f) => !tags || hasMatchingTags(f.tag))
              .map((facet) => (
                <FiltersControlFacet
                  id={facet.id}
                  label={facet.label}
                  key={facet.id}
                  multiple={facet.multiple}
                  type={facet.type}
                  isFrontendId={facet.isFrontendId}
                />
              ))}
          </div>
        </div>
      )}

      {!!config.fields?.length && (
        <div className="filters-controlsection">
          <div className="filters-controlsection-label">
            <span>
              <FormattedMessage id="overview.controls.field.label" />
            </span>
          </div>

          <div className="filters-controlsection-controls">
            {config.fields.map((field) => (
              <FiltersControlField
                id={field.id}
                label={field.label}
                key={field.id}
              />
            ))}
          </div>
        </div>
      )}

      {!!config.sorting?.length && (!tags || hasMatchingTags(config.sorting.tag)) && (
        <div className="filters-controlsection">
          <div className="filters-controlsection-label">
            <span>
              <FormattedMessage id="overview.controls.sort.label" />
            </span>
          </div>

          <div className="filters-controlsection-controls">
            <FiltersControlSorting />
          </div>
        </div>
      )}
    </>
  );

  if (wrapper) {
    return <div className={wrapperClassNames}>{filters}</div>;
  } else {
    return filters;
  }
};

Filters.propTypes = {
  viewId: PropTypes.string,
  onChange: PropTypes.func,
};

export default Filters;
